<template>
    <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
        <div class="delete-modal">
            <h4 class="pb-4 text-left font-semibold">Acknowledgement</h4>
            <div class="flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="104" height="103" viewBox="0 0 104 103" fill="none">
                    <circle cx="52" cy="51.5" r="51.5" fill="#27AE60" fill-opacity="0.2" />
                    <circle cx="51.9998" cy="51.4998" r="41.2" fill="#27AE60" fill-opacity="0.4" />
                    <circle cx="51.9996" cy="51.4996" r="30.9" fill="#27AE60" fill-opacity="0.6" />
                    <path
                        d="M48.7775 55.2659L44.8785 51.3993L43.5 52.7663L48.7775 58L59.5 47.367L58.1215 46L48.7775 55.2659Z"
                        fill="white" />
                </svg>
            </div>

            <div class="my-6">
                <p>Thank you for your feedback! </p>
            </div>
            <div>
                <button class="py-2 w-full text-center bg-secondary-yellow rounded" @click="closeModal()">Ok</button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        showModal: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            showDeclineReasonModal: false
        }
    },

    methods: {
        closeModal() {
            this.showDeclineReasonModal = true
            this.$emit("close-modal");
            this.$router.push("/user/rating")
        },
    }
};
</script>

<style scoped>
.delete-modal {
    text-align: center;
}
</style>